export default {
  init() {

  },

  finalize() {
    /**
     * Load more posts.
     */

    function load_more() {
      let $els = $('.quick-link.d-none');

      if ($els.length > 9) {
        let to_show = $els.splice(0, 9);
        $(to_show).removeClass('d-none');
      } else {
        $els.removeClass('d-none');
        $('#show-more').hide();
      }
    }

    load_more();

    $('#show-more').click(function () {
      load_more()
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/template-listing.js